import React from "react";
import withStyles from "react-jss";
import { Link } from "react-router-dom";
import NoIndex from "ComponentsUI/NoIndex";

const styles = theme => {
    return {
        root: {
            padding: "0 30px 30px",
        },
        header: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "65px",
        },
        headerMain: {
            fontFamily: theme.fonts.bold,
            fontSize: "24px",
            lineHeight: 0.75,
            color: theme.palette.colors.addressBlackHeader,
        },
        headerMainAlt: {
            fontFamily: theme.fonts.bold,
            fontSize: "24px",
            lineHeight: 0.9,
            color: "#2b1d5d",
            wordWrap: "break-word",
            width: "100%",
        },
        headerSecondary: {
            fontFamily: theme.fonts.bold,
            fontSize: "16px",
            lineHeight: 1,
            letterSpacing: "2.3px",
            color: theme.palette.colors.purplishBlue,
            textTransform: "uppercase",
            cursor: "pointer",
        },
        list: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexWrap: "wrap",
            marginRight: "-20px",
        },
        col: {
            width: "180px",
            marginBottom: "45px",
            marginRight: "20px",
        },
        colHeader: {
            fontFamily: theme.fonts.bold,
            fontSize: "16px",
            lineHeight: 1,
            color: theme.palette.colors.darkSlateBlue,
            marginBottom: "21px",
        },
        colItem: {
            "& a": {
                fontFamily: theme.fonts.medium,
                fontSize: "14px",
                lineHeight: 1.71,
                color: theme.palette.colors.oneMoreGrey,
                textOverflow: "ellipsis",
                overflow: "hidden",
                cursor: "pointer",
            },
        },
        alphabet: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexWrap: "wrap",
            marginRight: "-20px",
            padding: "0 70px",
        },
        alphabetCol: {
            width: "180px",
            marginBottom: 0,
            marginRight: "20px",
        },
        alphabetBlock: {
            width: "100%",
            position: "relative",
            marginBottom: "24px",
            paddingLeft: "30px",
        },
        alphabetColHeader: {
            position: "absolute",
            top: "4px",
            left: 0,
            fontFamily: theme.fonts.bold,
            fontSize: "14px",
            lineHeight: 1.14,
            color: theme.palette.colors.darkSlateBlue,
        },
        alphabetColItem: {
            lineHeight: 2,
            "& a": {
                fontFamily: theme.fonts.medium,
                fontSize: "14px",
                lineHeight: 2,
                color: theme.palette.colors.oneMoreGrey,
                textOverflow: "ellipsis",
                overflow: "hidden",
                cursor: "pointer",
            },
        },
        [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
            root: {
                padding: "0 30px 30px",
            },
            col: {
                width: "220px",
                marginBottom: "35px",
            },
            alphabet: {
                padding: "0, 50px",
            },
            alphabetCol: {
                width: "170px",
            },
        },
        [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
            root: {
                padding: "0 20px 30px",
            },
            header: {
                paddingBottom: "50px",
            },
            headerMain: {
                fontSize: "18px",
                lineHeight: 1,
            },
            headerSecondary: {
                fontSize: "14px",
                lineHeight: 1.14,
                letterSpacing: "2px",
            },
            list: {
                marginRight: 0,
            },
            col: {
                width: "100%",
                marginBottom: "45px",
                marginRight: 0,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
            },
            colHeader: {
                fontSize: "14px",
                lineHeight: 1.14,
                marginBottom: "11px",
                width: "100%",
            },
            colItem: {
                width: "110px",
                marginRight: "70px",
                "&:nth-child(3n+1)": {
                    marginRight: 0,
                },
            },
            alphabet: {
                marginRight: 0,
            },
            alphabetCol: {
                width: "50%",
                marginBottom: 0,
                marginRight: 0,
            },
            alphabetBlock: {
                paddingLeft: "60px",
            },
            alphabetColItem: {
                width: "170px",
            },
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            root: {
                padding: "0 0px 30px",
            },
            header: {
                paddingBottom: "33px",
                alignItems: "flex-start",
            },
            headerMain: {
                fontSize: "18px",
                lineHeight: 1,
            },
            headerSecondary: {
                fontSize: "14px",
                lineHeight: 1.14,
                letterSpacing: "2px",
                marginLeft: "30px",
                flexShrink: 0,
                marginTop: "2px",
            },
            list: {
                marginRight: 0,
            },
            col: {
                width: "100%",
                marginBottom: "33px",
                marginRight: 0,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
            },
            colHeader: {
                width: "100%",
            },
            colItem: {
                width: "100%",
            },
            alphabet: {
                marginRight: 0,
                padding: "0 50px",
            },
            alphabetCol: {
                width: "50%",
                marginBottom: 0,
                marginRight: 0,
            },
            alphabetBlock: {},
            alphabetColItem: {
                width: "40%",
                marginTop: "1px",
                marginBottom: "1px",
            },
        },
    };
};

class ListOfHouses extends React.PureComponent {
    static defaultProps = {
        showAlphabet: false,
        onItemSelect: () => {},
        type: "districts",
        isSwitchView: false,
        isBlockLetterView: true,
        listHeader: "",
    };

    constructor(props) {
        super(props);
        this.state = {
            showAlphabet: this.props.showAlphabet,
        };
    }

    changeOrder() {
        this.setState({
            showAlphabet: !this.state.showAlphabet,
        });
    }

    onSelectRegionHandler(region) {
        this.props.onItemSelect(region);
    }

    generateListHeader(text, onClick) {
        let classes = this.props.classes;
        return (
            <div className={classes.headerSecondary} onClick={onClick}>
                {text}
            </div>
        );
    }

    generateRegions() {
        let { items } = this.props;
        let classes = this.props.classes;
        return items.map((item, index) => {
            let streetsArray = item.s.map((item, index) => {
                return (
                    <div
                        onClick={() => this.onSelectRegionHandler(item)}
                        key={index}
                        className={classes.colItem}
                    >
                        <Link to={item.link}>{item.name}</Link>
                    </div>
                );
            });
            return (
                <div key={index} className={classes.col}>
                    <div className={classes.colHeader}>{item.name}</div>
                    {streetsArray}
                </div>
            );
        });
    }

    generateAlphabetical = () => {
        let {
            defaultItems,
            windowSizes: { lg, md, sm, xs },
            isBlockLetterView,
        } = this.props;
        let classes = this.props.classes;

        function toNextColumn() {
            if (objectsInBlock.length) {
                blockInColumns.push(
                    <div key={blocksCounter} className={classes.alphabetBlock}>
                        {isBlockLetterView && (
                            <div className={classes.alphabetColHeader}>
                                {blockLetter}
                            </div>
                        )}
                        {objectsInBlock}
                    </div>
                );
            }

            blocksCounter = 0;
            columns.push(
                <div key={columnsCounter} className={classes.alphabetCol}>
                    {blockInColumns}
                </div>
            );

            columnsCounter++;

            currentHeight = 0;
            objectsInBlock = [];
            blockInColumns = [];
        }

        function toNextBlock() {
            blockInColumns.push(
                <div key={blocksCounter} className={classes.alphabetBlock}>
                    {isBlockLetterView && (
                        <div className={classes.alphabetColHeader}>
                            {blockLetter}
                        </div>
                    )}
                    {objectsInBlock}
                </div>
            );
            currentHeight += defaultBlockMargin;
            blocksCounter++;
            objectsInBlock = [];
        }

        let columns = [];
        let columnsCounter = 0;
        let blockInColumns = [];
        let blocksCounter = 0;
        let objectsInBlock = [];
        let currentHeight = 0;
        let maxHeight = 720;
        if (md) maxHeight = 890;
        let itemHeight = 24;
        let defaultBlockMargin = 24;
        let blockLetter = defaultItems[0].name.substring(0, 1);
        let testHeight = 0;
        if (lg || md) {
            for (var i = 0; i < defaultItems.length; i++) {
                if (defaultItems[i].name.substring(0, 1) !== blockLetter) {
                    testHeight += defaultBlockMargin;
                    blockLetter = defaultItems[i].name.substring(0, 1);
                }
                testHeight += itemHeight;
            }
            if (lg) {
                maxHeight = testHeight / 5 + itemHeight;
            } else {
                maxHeight = testHeight / 4 + itemHeight;
            }
        }
        if (sm || xs) {
            for (var i = 0; i < defaultItems.length; i++) {
                if (defaultItems[i].name.substring(0, 1) !== blockLetter) {
                    testHeight += defaultBlockMargin;
                    blockLetter = defaultItems[i].name.substring(0, 1);
                }
                testHeight += itemHeight;
            }
            maxHeight = testHeight / 2 + itemHeight;
        }
        blockLetter = defaultItems[0].name.substring(0, 1);
        for (var i = 0; i < defaultItems.length; i++) {
            let item = defaultItems[i];
            let service = 0;
            if (item.district && item.district.service == 1) {
                service = 1;
            }
            if (item.name.substring(0, 1) !== blockLetter) {
                toNextBlock();
                i--;
                blockLetter = item.name.substring(0, 1);
                continue;
            }
            let houseName = item.name.split(" ").join("&nbsp");
            let viewHouse = "";
            if (service == 1) {
                viewHouse = item.full;
            } else {
                viewHouse = houseName;
            }
            if (currentHeight + itemHeight <= maxHeight) {
                let selectHouse = <div
                    onClick={() => this.onSelectRegionHandler(item)}
                    key={i}
                    className={classes.alphabetColItem}
                >
                    <Link
                        to={item.link}
                        onClick={
                            !!item.onClickHandler
                                ? item.onClickHandler
                                : null
                        }
                        dangerouslySetInnerHTML={{ __html: viewHouse }}
                        rel={item.houseUrl ? "" : "nofollow"}
                    ></Link>
                </div>
                objectsInBlock.push(
                    item.houseUrl ? selectHouse : <NoIndex>{selectHouse}</NoIndex>
                );

                currentHeight += itemHeight;
                if (i == defaultItems.length - 1) {
                    toNextColumn();
                }
            } else {
                toNextColumn();
                i--;
            }
        }
        return columns;
    };

    _renderView() {
        let {
            windowSizes: { lg, md },
            type,
            isSwitchView,
            text,
        } = this.props;
        if (!isSwitchView) return null;
        let { showAlphabet } = this.state;
        let alphabetString =
            lg || md
                ? text.SEO_ADDRESS_SORT_ALPHABET_LG
                : text.SEO_ADDRESS_SORT_ALPHABET_MD;
        let districtString =
            lg || md
                ? text.SEO_ADDRESS_SORT_DISTRICTS_LG
                : text.SEO_ADDRESS_SORT_DISTRICTS_MD;
        return (
            <div>
                {!showAlphabet &&
                    this.generateListHeader(alphabetString, () =>
                        this.changeOrder()
                    )}
                {showAlphabet &&
                    this.generateListHeader(districtString, () =>
                        this.changeOrder()
                    )}
            </div>
        );
    }

    render() {
        let { defaultItems, listHeader, altHeader } = this.props;
        let classes = this.props.classes;
        if (defaultItems.length == 0) return null;
        let { showAlphabet } = this.state;
        return (
            <div className={classes.root}>
                <div className={classes.header}>
                    <div
                        className={
                            altHeader
                                ? classes.headerMainAlt
                                : classes.headerMain
                        }
                    >
                        {listHeader}
                    </div>
                    {this._renderView()}
                </div>
                {!showAlphabet && (
                    <div className={classes.list}>{this.generateRegions()}</div>
                )}
                {showAlphabet && (
                    <div className={classes.alphabet}>
                        {this.generateAlphabetical()}
                    </div>
                )}
            </div>
        );
    }
}

export default withStyles(styles)(ListOfHouses);
